const PackageTypes = Object.freeze({
  FREE: 'Free plan',
  PREMIUM: 'Premium plan',
  PREMIUM_PLUS: 'Premium Plus plan',
  PRO: 'Pro plan',
  CUSTOM: 'Custom plan',
});

export default PackageTypes;
